import { Box, Button, Typography, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AlertsTableWrapper from './AlertsTableWrapper';
import CaptureExportControls from 'utils/CaptureExportControls';
import { ExportIcon } from 'components/CommonIcons/Icons';

interface AlertsTablePageProps {
  onBack: () => void;
  onScreenshot: () => void;
  screenCapturing: boolean;
  onExport: () => void;
  isExporting: boolean;
}

const AlertsTablePage = ({
  onBack,
  onScreenshot,
  screenCapturing,
  onExport,
  isExporting,
}: AlertsTablePageProps) => {
  return (
    <Box sx={{ width: '100%' }}>
     <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 3,
          gap: 2,
        }}
      >
        <Button
          variant="text"
          startIcon={<ArrowBackIcon sx={{ color: '#003771' }} />}
          onClick={onBack}
        >
          Back
        </Button>

        <CaptureExportControls
          onScreenshot={onScreenshot}
          screenCapturing={screenCapturing}
          onExport={onExport}
          isExporting={isExporting}
          showExport={true}
          isVisible={true}
          type="snow"
          exportTooltip="Max 200K records will be exported at a Time."
        />
      </Box>
      <Box id="ua-table-capture-area">
        <Typography
          variant="h6"
          sx={{ color: 'primary.main' }}
        >
          No Date Range
        </Typography>

        <AlertsTableWrapper />
      </Box>
    </Box>
  );
};

export default AlertsTablePage;